import { useTranslation } from 'react-i18next';
import { retailTargetRoles } from '@/mocks/corporateRetailData';

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function TargetRoles() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          {renderParagraphs(
            String(t('corporateRetail.target.label')),
            'text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label',
          )}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporateRetail.target.title')}
          </h2>
          {renderParagraphs(
            String(t('corporateRetail.target.titleEn')),
            'section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4',
          )}
          <div className="gold-line mx-auto mb-5"></div>
          {renderParagraphs(
            String(t('corporateRetail.target.lead')),
            'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[600px] mx-auto',
          )}
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {retailTargetRoles.map((_role, idx) => (
            <span
              key={idx}
              className="inline-block px-5 py-2.5 bg-background-100/60 border border-background-200/60 text-[15px] text-foreground-700 tracking-[0.05em]"
            >
              {t(`corporateRetail.target.role${idx}`)}
            </span>
          ))}
        </div>

        <div className="bg-background-100/60 border border-background-200/60 p-6 text-center max-w-[500px] mx-auto">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-user-line text-accent-500"></i>
            </div>
            <span className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium">
              {t('corporateRetail.target.capacity')}
            </span>
          </div>
          {renderParagraphs(
            String(t('corporateRetail.target.capacityNote')),
            'text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed',
          )}
        </div>
      </div>
    </section>
  );
}
